<template>

<div class="py-3 text-center">
    
    <div class="py-2">
        <a :href="'https://twitter.com/intent/tweet?text='+message" class="btn btn-dark" target="_blank"><i aria-hidden="true" class="fab fa-twitter mr-2" style="color:#fff;"></i>Share on Twitter</a>
    </div>

    <div class="py-2">
        <a :href="'whatsapp://send?text='+message" class="btn btn-dark" target="_blank"><i aria-hidden="true" class="fab fa-whatsapp mr-2" style="color:#fff;"></i>Share on WhatsApp</a>
    </div>

    <div class="py-2">
        
        <a :href="'https://www.facebook.com/sharer/sharer.php?u='+url" class="btn btn-dark" target="_blank"><i aria-hidden="true" class="fab fa-facebook mr-2" style="color:#fff;"></i>Share on Facebook</a>
    </div>

    <div class="py-2">
        <a :href="'https://t.me/share/url?url='+url" class="btn btn-dark" target="_blank"><i aria-hidden="true" class="fab fa-telegram mr-2" style="color:#fff;"></i>Share on Telegram</a>
    </div>

    <div class="py-2">
        <a :href="`mailto:?subject=Check this out!&amp;body=${message}`" class="btn btn-dark" target="_blank"><i aria-hidden="true" class="fa-solid fa-envelope mr-2" style="color:#fff;"></i>Share on Email</a>
    </div>

</div>

</template> 

<script>
export default {
  props: ['url'],

  data() {
    return {
        message: 'I found this platform called Supalytic. It lets you hire web designers, app developers and other digital service professionals. You can also earn money by being a service provider or affiliate. Have a look by visiting '+this.url,
    };
  },

  created() {
    
  },

  methods: {
    
    
  }


}
</script>

<style scoped>
a.btn.btn-dark {
    width: 15rem !important;
}

</style>